export const reverseLatLngArray = (array) => {
  let points = []
  array.forEach(val => points.push([parseFloat(val[1]), parseFloat(val[0])]))
  return points
}
